import Backbone from '@polleverywhere/backbone'
import Base from './base.js'
import Instance from './mixins/_instance'

// Model that represents Join Instructions. Components that are passed
// this as the model should render the activity as Join Instructions.
export default class JoinInstructions extends Base {
  initialize (options = {}) {
    super.initialize(...arguments)
    this.set({
      type: 'join_instructions', // required for activity factory
      presenter_key: 'joinInstructions', // type required for Instance
      shared_key: 'joinInstructions' // type required for Instance
    })

    // id required for toolkit/components/visualization
    this.id = 'joinInstructions'

    // Instance required for lib/apps/activities
    this.include(Instance)

    // flashOptions required for activity-visualization + viz-chart
    this._flashOptions = new Backbone.Model({
      showInstructions: false
    })
  }

  // showUrl() required for toolkit/components/visualization
  showUrl () {
    return '/join_instructions'
  }

  // start() required for singularity/lib/apps/activities
  start () {}

  // type() required for Instance
  type () {
    return this.get('type')
  }

  // flashOptions() required for activity-visualization + viz-chart
  flashOptions () { return this._flashOptions }
}
